export enum SubTrackClosingReasonCode {
    // Het subtraject is niet afgesloten (te gebruiken bij trial aanleveringen)
    CRC00 = '0',

    // Afsluiten zorgtype 11 of 21 bij overlijden patiënt
    CRC02 = '2',

    // Afsluiten zorgtype 11 of 21 conform de algemene sluitregels van een klinisch subtraject
    CRC04 = '4',

    // Afsluiten zorgtype 11 of 21 conform de algemene sluitregels van een niet-klinisch subtraject met operatieve ingrepen
    CRC06 = '6',

    // Afsluiten zorgtype 11 conform de algemene sluitregels van een niet-klinisch subtraject met conservatieve behandeling
    CRC08 = '8',

    // Afsluiten zorgtype 11 of 21 wegens het bereiken van de maximale looptijd
    CRC12 = '12',

    // Afsluiten zorgtype 41 na uitvoering laatste zorgactiviteit in het kader van het OZP
    CRC16 = '16',

    // Afsluiten IC-traject met zorgtype 51 of 52 bij ontslag van IC
    CRC18 = '18',

    // Afsluiten zorgtype 11 of 21 o.b.v. uitzondering Cardiologie (1.0320.2) (deprecated)
    CRC41 = '41',

    // Afsluiten zorgtype 11 of 21 o.b.v. uitzondering Cardiologie (1.0320.3)
    CRC43 = '43',
}

export function isSubtrackClosingReasonCode(value: string | null): value is SubTrackClosingReasonCode {
    return Object.values(SubTrackClosingReasonCode).includes(value as SubTrackClosingReasonCode);
}

export function stringToSubtrackClosingReasonCode(value: string | null): SubTrackClosingReasonCode {
    if (!isSubtrackClosingReasonCode(value)) {
        throw new Error(`Invalid SubTrackClosingReasonCode: ${value}`);
    }

    return value as SubTrackClosingReasonCode;
}
